export default [
    {
      path: '/home',
      name: 'home',
      component: () => import('@/views/sft/Home.vue'),
    },
  ]